import { useLocale } from '@gov-nx/core/service';
import type {
	LocaleDefinition,
	LocaleNoParams,
	LocaleVariables,
} from '@gov-nx/core/types';
import { PageCode } from '@gov-nx/module/page';

// TODO: Je mozny recyklovat uz nepouzivany preklady:
// detail.table.kod-sablony
// invalidation.form.pole.termination-date.now.label
// invalidation.form.pole.termination-date.on-date.label
// invalidation.form.pole.date.label
// invalidation.form.pole.termination-date.validace.povinne-pole

// invalidation.form.buttons.submit.wcag
// invalidation.form.buttons.submit.label

export type RezaLocaleObject = {
	akce: {
		filtrovat: {
			label: LocaleNoParams;
			wcag: LocaleNoParams;
		};
		'zrusit-filtr': {
			label: LocaleNoParams;
			wcag: LocaleNoParams;
		};
		'zobrazit-filtr': {
			wcag: LocaleNoParams;
		};
	};
	seznam: {
		item: {
			'platnost-od': {
				label: LocaleNoParams;
			};
			'platnost-do': {
				label: LocaleNoParams;
				empty: LocaleNoParams;
			};
			zmocnitel: LocaleNoParams;
			zmocnenec: LocaleNoParams;
			identifikator: LocaleNoParams;
		};
		search: {
			label: LocaleNoParams;
			placeholder: LocaleNoParams;
			button: {
				placeholder: LocaleNoParams;
			};
		};
		empty: LocaleNoParams;
		'no-all-displayed': LocaleNoParams;
		footer: LocaleVariables<'link'>;
		'footer-modal-form-description': LocaleNoParams;
		'footer-archive': LocaleVariables<'link'>;
		button: {
			reklamace: { label: LocaleNoParams };
		};
		filters: {
			'zahrnout-archivovane': LocaleNoParams;
			'zahrnout-archivovane-popis': LocaleNoParams;
			role: {
				zmocnitel: LocaleNoParams;
				zmocnenec: LocaleNoParams;
			};
			'platnost-od-od': LocaleNoParams;
			'platnost-od-do': LocaleNoParams;
			'platnost-do-od': LocaleNoParams;
			'platnost-do-do': LocaleNoParams;
			text: LocaleNoParams;
		};
		validace: {
			platnost: {
				min: LocaleVariables<'datum'>;
				// max: LocaleNoParams;
			};
			'platnost-do': {
				'starsi-nez-datum-od': LocaleNoParams;
			};
		};
		modal: {
			title: LocaleNoParams;
			'platnost-od': { label: LocaleNoParams };
			'platnost-do': { label: LocaleNoParams };
			'platnost-od-od': LocaleNoParams;
			'platnost-od-do': LocaleNoParams;
			'platnost-do-od': LocaleNoParams;
			'platnost-do-do': LocaleNoParams;
		};
	};
	detail: {
		description: LocaleNoParams;
		implicitni: {
			title: LocaleNoParams;
		};
		explicitni: {
			title: LocaleNoParams;
		};
		rozsah: LocaleNoParams;
		buttons: {
			pdf: LocaleNoParams;
			'ziskat-datovou-schranku': LocaleNoParams;
			reklamace: LocaleNoParams;
			ukoncit: LocaleNoParams;
			'zkopirovat-do-schranky': LocaleNoParams;
		};
		hlavicka: {
			zmocnitel: LocaleNoParams;
			zmocnenec: LocaleNoParams;
			popis: LocaleNoParams;
		};
		table: {
			identifikator: LocaleNoParams;
			'po-nazev': LocaleNoParams;
			'po-ico': LocaleNoParams;
			'po-sidlo': LocaleNoParams;
			'fo-jmeno': LocaleNoParams;
			'fo-datum-narozeni': LocaleNoParams;
			'fo-adresa': LocaleNoParams;
			'platnost-od': LocaleNoParams;
			'platnost-do': LocaleNoParams;
			'kod-opravneni': LocaleNoParams;
			postoupeni: {
				klic: LocaleNoParams;
				tooltip: LocaleNoParams;
				ano: LocaleNoParams;
				ne: LocaleNoParams;
			};
			sablona: LocaleNoParams;
			postupitelny: {
				klic: LocaleNoParams;
				tooltip: LocaleNoParams;
				ano: LocaleNoParams;
				ne: LocaleNoParams;
			};
			'typ-zastoupeni': {
				klic: LocaleNoParams;
				tooltip: LocaleNoParams;
				explicitni: LocaleNoParams;
				implicitni: LocaleNoParams;
			};
		};
		'seznam-postoupeni': {
			title: LocaleNoParams;
		};
		tag: {
			zmocnitel: LocaleNoParams;
		};
	};
	complaints: {
		title: LocaleNoParams;
		description: LocaleNoParams;
		form: {
			pole: {
				complaint: {
					label: LocaleNoParams;
					placeholder: LocaleNoParams;
					validace: { 'povinne-pole': LocaleNoParams };
				};
			};
			email: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
			phone: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
			buttons: {
				submit: {
					label: LocaleNoParams;
					wcag: LocaleNoParams;
				};
			};
			odeslano: LocaleNoParams;
		};
	};
	invalidation: {
		title: LocaleNoParams;
		description: LocaleNoParams;
		form: {
			pole: {
				'termination-date': {
					label: LocaleNoParams;
					now: {
						label: LocaleNoParams;
					};
					'on-date': {
						label: LocaleNoParams;
					};
					validace: { 'povinne-pole': LocaleNoParams };
				};
				date: {
					label: LocaleNoParams;
				};
			};
			buttons: {
				submit: {
					label: LocaleNoParams;
					wcag: LocaleNoParams;
				};
			};
		};
	};
	overview: {
		title: LocaleNoParams;
		ziskat: LocaleNoParams;
		form: {
			sendByDatabox: {
				label: LocaleNoParams;
				'uspesne-odeslano': LocaleNoParams;
			};
			databox: {
				label: LocaleNoParams;
			};
		};
	};
	usage: {
		title: LocaleNoParams;
		ziskat: LocaleNoParams;
		form: {
			sendByDatabox: {
				label: LocaleNoParams;
				'uspesne-odeslano': LocaleNoParams;
			};
			databox: {
				label: LocaleNoParams;
			};
			'platnost-od': {
				label: LocaleNoParams;
			};
			'platnost-do': {
				label: LocaleNoParams;
			};
			validace: {
				platnost: {
					min: LocaleVariables<'datum'>;
				};
				'platnost-do': {
					'starsi-nez-datum-od': LocaleNoParams;
				};
			};
			'date-range': {
				label: LocaleNoParams;
			};
		};
	};
	sablony: {
		detail: {
			table: {
				identifikator: LocaleNoParams;
				verze: LocaleNoParams;
				'platnost-od': LocaleNoParams;
				'platnost-do': LocaleNoParams;
				'platnost-do-neomezeno': LocaleNoParams;
				popis: LocaleNoParams;
				postupitelny: {
					klic: LocaleNoParams;
					ano: LocaleNoParams;
					ne: LocaleNoParams;
				};
			};
		};
		seznam: {
			title: LocaleNoParams;
			item: {
				popis: LocaleNoParams;
			};

			empty: LocaleNoParams;
		};
		pole: {
			hledat: {
				label: LocaleNoParams;
				placeholder: LocaleNoParams;
			};
		};
		buttons: {
			submit: {
				wcag: LocaleNoParams;
			};
		};
	};
	archiv: {
		seznam: {
			titulek: LocaleNoParams;
		};
	};
	toasts: {
		download: {
			success: LocaleVariables<'fileName'>;
			chyba: LocaleNoParams;
		};
	};
	stav: {
		chyba: {
			'zadny-zaznam': LocaleNoParams;
			'v-reza-nejsou-data': LocaleNoParams;
		};
	};
};

export const useRezaLocale = (): LocaleDefinition<RezaLocaleObject> =>
	useLocale(PageCode['reza']);
